// Patient app auth uses REST API calls to /api/auth/* endpoints
// (no @supabase/supabase-js dependency — kept out of the bundle deliberately)

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''

export const supabase: any = null
export const isSupabaseConfigured = (): boolean => !!supabaseUrl
